import { Palette } from '@common/theming/Palette';
import React from 'react';
import { InfoItem } from '../../types';
import { TextBlock } from '../TextBlock';

type InfoTableProps = {
  rows: InfoItem[];
  field: string;
};
const InfoTable: React.FC<InfoTableProps> = ({ rows, field }) => {
  return (
    <div style={{ backgroundColor: Palette.LIGHT_BLUE_GRAY, borderRadius: 10, paddingTop: 4 }}>
      {rows.map((row, i) => {
        return (
          <div
            key={`${field}-${i}`}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: 12,
            }}>
            <TextBlock style={{ color: Palette.WHITE_50 }}>{row.label}</TextBlock>
            <TextBlock weight={'bold'}>{row.value}</TextBlock>
          </div>
        );
      })}
    </div>
  );
};

export default InfoTable;
